import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../utils/constants";

export const UserDetailsSlice = createSlice({
  name: "UserDetailsData",
  initialState: {
    userData: [],
    capabilities: [],
    platform: [],
    error: false,
    success: null,
    loader: false,
  },
  reducers: {
    setUserData: (state, action) => {
      state.userData = (action.payload || []).map((user) => ({
        ...user,
        businessUnit: user?.businessUnit?.trim?.() ? user.businessUnit : "Song",
      }));
    },
    setCapabilities: (state, action) => {
      state.capabilities = action.payload;
    },
    setPlatform: (state, action) => {
      state.platform = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    resetStatus: (state) => {
      state.error = null;
      state.success = null;
    },
  },
});

export const {
  setUserData,
  setCapabilities,
  setPlatform,
  setError,
  setSuccess,
  setLoader,
  resetStatus,
} = UserDetailsSlice.actions;

export default UserDetailsSlice.reducer;

export function getUserData(enterpriseId) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .post(
        `${BASE_API_URL}/getUser`,
        { enterpriseId },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setUserData(res.data));
        dispatch(setLoader(false));
        dispatch(setError(null));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}

export function addUserData(name, enterpriseId, role, level, photo) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .post(
        `${BASE_API_URL}/addUser`,
        { name, enterpriseId, role, level, photo },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getUserData(enterpriseId));
        dispatch(setError(null));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setLoader(false));
        dispatch(setError(err));
      });
  };
}

export function updateUserData(formData) {
  return (dispatch) => {
    dispatch(setLoader(true));

    axios
      .post(`${BASE_API_URL}/updateUser`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        dispatch(getUserData(formData.get("enterpriseId")));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}

export function syncUser(enterpriseId, name, level, role) {
  return (dispatch) => {
    dispatch(setLoader(true));

    axios
      .post(
        `${BASE_API_URL}/syncUser`,
        { enterpriseId, name, level, role },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then(() => {
        dispatch(getUserData(enterpriseId));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        console.error("syncUser error", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}
export function getCapability(enterpriseId) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .get(`${BASE_API_URL}/capability`, {
        params: { enterpriseId },
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setCapabilities(res.data));
        dispatch(setLoader(false));
        dispatch(setError(null));
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}
export function getCategory(enterpriseId) {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .get(`${BASE_API_URL}/category`, {
        params: { enterpriseId },
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setPlatform(res.data));
        dispatch(setLoader(false));
        dispatch(setError(null));
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}
export function uploadUserData(businessUnit, file) {
  return (dispatch) => {
    dispatch(setLoader(true));
    dispatch(resetStatus());

    const formData = new FormData();
    formData.append("file", file);
    formData.append("businessUnit", businessUnit);

    axios
      .post(`${BASE_API_URL}/uploadUsers`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setSuccess(res.data.message || "Users uploaded successfully"));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        dispatch(setError(err.response?.data?.message || "Upload failed"));
      });
  };
}
